import { SWRConfig } from 'swr'
import { RouterProvider } from 'react-router-dom'
import { router } from '@/routing'
import { swrConfig } from '@/lib/swr'
import { AuthInitializer, Toaster } from '@/shared/components'

function App() {
  return (
    <SWRConfig value={swrConfig}>
      <AuthInitializer>
        <RouterProvider router={router} />
        <Toaster />
      </AuthInitializer>
    </SWRConfig>
  )
}

export default App
